<div class="page-holder bg-gray-100">
  <div class="container-fluid px-lg-4 px-xl-5 min-w-viewport">
    <!-- Page Header-->
    <div class="page-header d-flex justify-content-between align-items-center">
      <h1 class="page-heading">All Forms</h1>
      <div><a class="btn btn-primary text-uppercase"> <i class="fa fa-plus me-2"> </i>Add new</a></div>
    </div>

    <div class="row mb-5">
      <div class="col-md-4 mb-4" *ngFor="let row of allFormsData">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="card-heading">{{row.title}}</h6>
            <div class="form-tags">
              <span class="badge badge-success-light me-2">{{row.buName}}</span>
              <span class="badge badge badge-info-light">{{row.facilityName}}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="mb-3">{{row.body}}</div>
          </div>
          <div class="card-footer text-end">
            <a class="me-3 text-lg text-success cursor-pointer"><i class="far fa-edit"></i></a>
            <a class="me-3 text-lg text-success cursor-pointer"><i class="fab fa-wpforms"></i></a>
            <a class="me-3 text-lg text-success cursor-pointer"><i class="fas fa-user-edit"
                (click)="utilService.navigateWithState('assignment',row)"></i></a>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 mb-4" *ngFor="let row of allFormsData">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="card-heading">{{row.title}}</h6>
            <div class="form-tags">
              <span class="badge badge-success-light me-2">{{row.buName}}</span>
              <span class="badge badge badge-info-light">{{row.facilityName}}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="mb-3">{{row.body}}</div>
          </div>
          <div class="card-footer text-end">
            <a class="me-3 text-lg text-success cursor-pointer"><i class="far fa-edit"></i></a>
            <a class="me-3 text-lg text-success cursor-pointer"><i class="fab fa-wpforms"></i></a>
            <a class="me-3 text-lg text-success cursor-pointer"><i class="fas fa-user-edit"
                (click)="utilService.navigateWithState('assignment',row)"></i></a>
          </div>
        </div>
      </div>
    </div>
    <!-- <section class="mb-5">
        <div class="card card-table">
          <div class="preload-wrapper opacity-10">
            <table class="table table-hover align-middle mb-0" id="postDatatable">
              <tbody>
                <tr *ngFor="let row of allFormsData">
                    <td>
                        <div class="header">{{row.title}}</div>
                        <div>
                        {{row.body}}
                        </div>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section> -->
  </div>
  <div *ngIf="httpService.processing()">
    <app-progress-indicator></app-progress-indicator>
  </div>
  <app-footer class="footer-w"></app-footer>
</div>